import React from "react";
import Entity from "../Entity";

class Story extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      story: props.story
    };
  }

  captionWithEntity (caption, entity) {
    const parts = caption.split(entity.name);
    const result = [];

    parts.forEach((part, index) => {
      if (index !== 0) {
        result.push(<Entity entity={entity} key={`entity-${entity.id}-${index}`} />);
      }

      const innerHtml = { __html: part };
      result.push(<span dangerouslySetInnerHTML={innerHtml} key={`caption-${entity.id}-${index}`} />);
    });

    return result;
  }

  formatDate (date) {
    const formatDateElement = function (element) {
      if (element < 10) {
        return "0" + element;
      }
      return element;
    };
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();
    const hours = formatDateElement(d.getHours());
    const minutes = formatDateElement(d.getMinutes());

    if (month.length < 2) { month = "0" + month; }
    if (day.length < 2) { day = "0" + day; }
    return [year, month, day].join("-") + " " + hours + ":" + minutes;
  }
}

export default Story;
